import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch,Switch, Route ,Link} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
  TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,Timer,AudioLines,
  FolderHeart, Forward,Earth,ListChecks,Gift,Settings,BetweenHorizontalStart,
  ImagePlay,Film,AlarmSmoke,BellElectric,CircleCheck,LayoutGrid ,CornerDownRight,BotMessageSquare,ChevronUp,ChevronDown,
  GripHorizontal,
  CopyPlus,
  Bookmark,
  Pencil,
  Trash2,
  Recycle} from 'lucide-react';import Snackbar from "../../../Snackbar";
import ContentFolderCard from "./ContentFolderCard";
import CreateFolderPopup from "./ContentPopUp/CreateFolderPopup";
import CreateSubCoursePopUp from "./SubCourse/CreateSubCoursePopUp";
import { getAllSubCoursesByCourseId } from "../../../store/actions/CreateContent/OrganizeAPI/SubCoursesAPIs";
import SubCoursesPanel from "./SubCourse/SubcoursesPanel";

const CreateCourseSubcourseAndMilestones =({selectCoursePopUp})=>{

     const dispatch = useDispatch();
         const user = useSelector((state)=>state?.user?.user);
              const [selectCoursePopUpIn, setSelectCoursePopUp] =useState(selectCoursePopUp);   
                      
                      
         const [snackbarVisible, setSnackbarVisible] = useState(false);
                          const [snackbarColor, setSnackbarColor] = useState("#958FDA");
                          const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
                    
                                  const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
                       const showSnackbar = () => {
                         setSnackbarVisible(true);
                       };
                      
                       const hideSnackbar = () => {
                         setSnackbarVisible(false);
                       };
                 
                 
                            
                            
                         
                        const [animate, setAnimate] = useState(false);
          
           const [loader , setLoader] =useState({status:true});
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
      const [openAppDesignPopUp,setopenAppDesignPopUp]  = useState(false);
      const [openAppDesignPopUpInnerContent,setopenAppDesignPopUpInnerContent]  = useState("appThemes");

      
const token = useSelector((state)=>state?.course?.course?.token);
       const currentToken = useSelector((state)=>state?.user?.user?.token);
       const user_email = useSelector((state)=>state?.user?.user?.user_email
      );
      
      const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
      
      const courseData = useSelector((state)=>state?.course?.course);
      
      const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
     
          
           const [visibility,setVisibility] =useState("public");
           const [orderBy,setOrderBy] =useState("ASC");
           const [itemArr, setItemArr] = useState([]);
           const [itemReorderArr, setItemReorderArr] = useState([]);
           const [itemId, setItemId] = useState("");
           const [deleteSubCoursePopUp, setDeleteSubCoursePopUp] = useState(false);
           const [itemArrLoading, setItemArrLoading] = useState([{},{},{},{},{},{}]);
           const [openContentInFolder, setOpenContentInFolder] = useState("");
           
 const [subCourseItem ,setSubCourseItem] =useState({});
 const updateItemTitle = (ID, newTitle) => {
  const updatedItems = itemArr.map(item =>
    item?.ID === ID ? { ...item, Name :newTitle } : item
  
  ); 

 // console.log(updatedItems)
  setItemArr(updatedItems);
};
const sendBackSubCOurse = (subCourse) => {
  const updatedItems = [...itemArr, subCourse]
  const updatedItemsMenuorder = [...itemReorderArr, {ID:subCourse?.ID,menuOrder:subCourse?.menuOrder}]
  setItemReorderArr( updatedItemsMenuorder);
 // console.log(updatedItems)
  setItemArr(updatedItems);
};

      

    return (<>
        {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor} onClose={hideSnackbar} />
      )}
        <div className=" "> 
          <SubCoursesPanel selectCoursePopUp={(selectCoursePopUp)=>{setSelectCoursePopUp(selectCoursePopUp);}}/>
          </div></>)
}
export default CreateCourseSubcourseAndMilestones;

